import { render, staticRenderFns } from "./Convivencia.vue?vue&type=template&id=7de46da0&scoped=true"
import script from "./Convivencia.vue?vue&type=script&lang=js"
export * from "./Convivencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de46da0",
  null
  
)

export default component.exports